import React from "react";
import { useNavigate } from "react-router-dom";
import CreateStarChartOrgActionPresentation from "../../presentation/createStarChartOrg/CreateStarChartOrgActionPresentation";
type ExperienceActionContainerProps = {
  onTerm: (e: React.ChangeEvent<HTMLInputElement>) => void;
  listStatus: string;
  onStudents: () => void;
  onExperiences: () => void;
  term: string;
  lastPosition: number;
};
const CreateStarChartOrgActionContainer: React.FC<ExperienceActionContainerProps> = ({
  onTerm,
  listStatus,
  onStudents,
  onExperiences,
  term,
  lastPosition,

}) => {
  const navigation = useNavigate()
  const onCreateExperience = () => {
    navigation('/experience/expdetails',{state : {isPrerequisites : false, lastPosition : lastPosition}})
  }

  return (
    <>
            <CreateStarChartOrgActionPresentation
              onCreateExperience={onCreateExperience}
              onTerm={onTerm}
              listStatus={listStatus}
              onStudents={onStudents}
              onExperiences={onExperiences}
              term={term}
            />
      
            

        
    </>
   )

}

export default CreateStarChartOrgActionContainer
